import Flex from 'components/Flex'
import {
  BoxFlexWrap,
  RemarksInfo,
  SkilsBox,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/style'
import React from 'react'

const TextRadioButton = ({ selectedReason, setSelectedReason }) => {
  const remarkData = [
    {
      value: 'Overqualified ',
      label: 'Overqualified ',
    },
    {
      value: 'Emp/ Education gap ',
      label: 'Emp/ Education gap ',
    },
    {
      value: 'Others are better',
      label: 'Others are better',
    },
  ]

  const onClcikScore = value => {
    setSelectedReason(value)
  }

  return (
    <div>
      <RemarksInfo>Add Remarks</RemarksInfo>
      <BoxFlexWrap spaceBetween>
        {remarkData?.map((remark, index) => (
          <Flex key={index + remark?.label}>
            <SkilsBox
              width
              onClick={() => onClcikScore(remark?.value)}
              isSelected={selectedReason === remark?.value}
            >
              {remark?.label}
            </SkilsBox>
          </Flex>
        ))}
      </BoxFlexWrap>
    </div>
  )
}

export default TextRadioButton
